import React from 'react';
import { Shield, Award, Users, TrendingUp, Clock } from 'lucide-react';
import { Card } from './ui/card';

const About = () => {
  const features = [
    {
      icon: TrendingUp,
      title: 'Risultati Misurabili',
      description: 'Strategie data-driven che generano un ROI concreto e una crescita riscontrabile per il tuo business.'
    },
    {
      icon: Shield,
      title: 'Protezione Legale',
      description: 'Team Legale di esperti dedicato per tutelare il tuo brand da plagio, contenziosi e gestione degli "Haters".'
    },
    {
      icon: Users,
      title: 'Team Dedicato 24/7',
      description: 'Creazione ad hoc di un team di esperti in Social Media, Marketing, Amministrazione e Supporto Legale.'
    },
    {
      icon: Award,
      title: 'Garanzia di Qualità',
      description: 'Il 100% dei nostri Clienti è soddisfatto dopo i primi 30 giorni di collaborazione. La tua crescita è la nostra priorità.'
    }
  ];

  const stats = [
    {
      value: '+250%',
      label: 'Conversioni medie',
      sublabel: 'dopo 30 giorni'
    },
    {
      value: '100%',
      label: 'Clienti soddisfatti',
      sublabel: 'dopo 30 giorni'
    },
    {
      value: '24/7',
      label: 'Copertura e Supporto',
      sublabel: 'garantiti'
    }
  ];

  return (
    <section id="chi-siamo" className="relative bg-black py-24 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-b from-black via-blue-950/5 to-black" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            <span className="text-gray-500">Chi</span>{' '}
            <span className="text-white">Siamo</span>
          </h2>
          <p className="text-gray-400 text-lg mx-auto leading-relaxed">
            Siamo un'agenzia specializzata nella gestione di account Social Media con un track record 
            di risultati oggettivi e comprovabili. Oltre alla strategia digitale, offriamo supporto completo: 
            sia quello operativo di Community Management (Chatter, Sales and Account Manager) sia quello 
            Amministrativo, Finanziario, Contabile e soprattutto Legale così da non limitarci ad incrementare 
            i numeri e le conversioni dei Creator con cui collaboriamo ma andandoli altresì a tutelare da 
            contenziosi, tentativi di furto, plagio e gestione degli "Haters".
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <Card
                key={index}
                className="bg-white/5 border-white/10 hover:bg-white/10 hover:border-blue-500/50 transition-all duration-500 p-6 text-center"
              >
                <div className="flex justify-center mb-4">
                  <div className="w-12 h-12 rounded-full bg-blue-500/10 flex items-center justify-center">
                    <Icon className="h-6 w-6 text-blue-400" />
                  </div>
                </div>
                <h3 className="text-lg font-semibold text-white mb-2">
                  {feature.title}
                </h3>
                <p className="text-sm text-gray-400">
                  {feature.description}
                </p>
              </Card>
            );
          })}
        </div>

        {/* Stats Banner */}
        <div className="bg-gradient-to-r from-blue-950/20 to-blue-900/20 border border-blue-500/20 rounded-2xl p-8 md:p-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            {stats.map((stat, index) => (
              <div key={index}>
                <div className="text-4xl md:text-5xl font-bold text-white mb-2">
                  {stat.value}
                </div>
                <div className="text-sm md:text-base text-gray-400">
                  {stat.label}
                  <br />
                  <span className="text-xs text-gray-500">{stat.sublabel}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;